import React, { useEffect, useState, useContext, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setHeaderOffset } from "../../redux/reducers/checkoutReducer";

const OVERLAY_WIDTH = 991;

export const useHeaderState = () => {
  const dispatch = useDispatch();
	const [scroll, setScroll] = useState(0);
	const [contentMargin, setContentMargin] = useState(0);
	const [minHeaderHeight, setMinHeaderHeight] = useState(0);
	const [headerWrapperNode, setHeaderWrapperNode] = useState(null);
	const [headerNode, setHeaderNode] = useState(null);
	const [overlayEnabled, setOverlayEnabled] = useState(false);

	const headerRef = useCallback(setHeaderNode, []);

	const headerWrapperRef = useCallback(setHeaderWrapperNode, []);

	const handleScroll = () => {
		setScroll(window.scrollY);
	};

	const handleResize = () => {
		setOverlayEnabled(window.innerWidth > OVERLAY_WIDTH);
		setMinHeaderHeight(0);
	};

  useEffect(() => {
    if (headerNode) {
      const observer = new ResizeObserver((entries) => {
        for (let entry of entries) {
          dispatch(setHeaderOffset(entry.contentRect.height));   
        }
      })

      observer.observe(headerNode);

      return () => {
        observer.disconnect();
      }
    }
  }, [headerNode, dispatch]);

	useEffect(() => {
		if (headerNode) {
			if (headerWrapperNode.getBoundingClientRect().top < 0) {
				setContentMargin(minHeaderHeight === 0 ? headerNode.getBoundingClientRect().height : minHeaderHeight);
				setMinHeaderHeight((min) => min === 0 ? headerNode.getBoundingClientRect().height : min);
			} else {
				setContentMargin(0);
			}
		}
	}, [dispatch, headerNode, headerWrapperNode, scroll, minHeaderHeight]);

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		window.addEventListener('resize', handleResize);
		handleResize();
		return () => {
			window.removeEventListener('scroll', handleScroll);
			window.removeEventListener('resize', handleResize);
		};
	}, [window]);

	return {
		headerRef,
		headerWrapperRef,
		contentMargin,
		minHeaderHeight,
		overlayEnabled
	}
}